import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

class Termsandconditionspage extends Component {
  render() {
    return (
      <div>
          <br/> <br/>
        <section class="get-abtstarted-section text-center">
        <img
                              src="/assets/images/course/cyber-security-Awareness.jpg"
                              alt="Logo"
                              width="950"
                              height="360"
                            />
          <center>
            <h1 class="textcenter">
              {" "}
              Terms and Conditions{" "}
            </h1>
          </center>
        </section>
        <div aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <Link>
                <FontAwesomeIcon icon={faHome} /> &nbsp; HOME
              </Link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Terms and Conditions
            </li>
          </ol>
        </div>
        <br/> <br/>
        <section class="padding-default">
          <div class="row">
            <div>
              <h4 class="text-center">Terms of Use </h4>
              <p>Following terms shall have following meaning</p>
              <ol type="a">
                <li>
                  {" "}
                  ‘Platform’: Platform means the edu plus now online education
                  platform for e-classroom learning at www.eduplusnow.com.
                </li>
                <li>
                  {" "}
                  ‘Programmes’: Programmes means various online self-paced
                  courses at edu plus now online education Platform
                </li>
                <li>
                  {" "}
                  ‘Instructors’: Instructors means Programmers instructors whose
                  primary responsibility is to facilitate the learning of
                  students on the edu plus now online Platform.
                </li>
                <li>
                  {" "}
                  ‘Students’: Students means to learners who have enrolled for
                  the self-paced courses on the edu plus now online Platform and
                  have paid requisite Programme fees. Student will also be
                  referred to as ‘you’ or ‘yours’
                </li>
                <li>
                  Affiliates: An organization or a person that is connected to
                  edu plus now
                </li>
                <li>
                  edu plus now(Brand name of Udnav Erp Software Technologies Llp . means Udnav Erp Software Technologies Llp. a company defined under the Companies Act, 2013 and
                  having its registered office School Building S. No. 201/5/6B 9A/3P, 
                                    Pawar Public School Street, Pune, 
                                    Maharashtra 411 028, India.)
                </li>
                <li>
                  {" "}
                  Website means the domain that hosts the edu plus now online
                  education platform for e-classroom learning.{" "}
                </li>

                <li>
                  {" "}
                  Users means those who just browsing the edu plus now Platform
                  are considered “users” for the purpose of these Terms.
                </li>
                <li>
                  “Content” means any and all information and data which may
                  include but not be limited to text, software, scripts,
                  graphics, maps, photos, sounds, music, videos, logos, offers,
                  advertisements, interactive features and other materials.
                </li>
                <br />
                <h5>
                  These Terms of Use (collectively called “Terms”) were last
                  updated on February 7, 2019.
                </h5>
              </ol>

              <ol>
                <li>
                  {" "}
                  The website, eduplusnow.com and the information, services and
                  other materials contained therein are provided and operated by
                  the
                  <h6> Udnav Erp Software Technologies Llp.</h6>
                </li>

                <li>
                  edu plus now offers specially designed technical and
                  industry-relevant certification programmes online
                </li>

                <li>
                  We upload course contents as prepared by the Instructors on
                  the Website{" "}
                </li>
                <li>
                  {" "}
                  Users interested to learn Programmers need to enroll for
                  Programmers of their choice.
                </li>

                <li>
                  {" "}
                  These terms and conditions shall regulate various Programme
                  being run by edu plus now and being pursued by Students
                  through edu plus now website, the mobile applications,
                  email/SMS/phone communication, social media channels and other
                  related services. Programme(s) may have special terms and
                  conditions which terms and conditions shall be deemed to have
                  been incorporated in these Terms of Use.{" "}
                </li>

                <li>
                  {" "}
                  Students need read these Terms of Use and Privacy Policy
                  carefully before they register/enroll for Programmes. Please
                  note that these Terms of Use may be modified at regular
                  intervals without prior notice. You are, therefore, advised to
                  review this page regularly. Your continued use of the edu plus
                  now Platform indicates that you have read and accepted the
                  changes. If you’re not satisfied with the terms, we advise you
                  not to use the platform.
                </li>

                <li>
                  {" "}
                  edu plus now makes no representations that the Platform
                  operates (or are legally permitted to operate) in all
                  geographic areas, or that the platform, or information,
                  services or products offered through the platform are
                  appropriate or available for use in other locations. Accessing
                  the platform from territories where the platform, or any
                  content or functionality of the platform or portions thereof
                  is illegal, is expressly prohibited. If you choose to access
                  the platform, you agree and acknowledge that you do so on your
                  own initiative and at your own risk and that you are solely
                  responsible for compliance with all applicable laws.
                </li>

                <li>
                  {" "}
                  You are responsible for all your activities in connection with
                  the use of the Programmes and Platform. You hereby agree to
                  fully comply with all applicable local, provincial, state,
                  national and foreign laws, treaties and regulations in
                  connection with such use. You shall not resort to any
                  unethical practices while using the platform.
                </li>

                <li>
                  {" "}
                  Without limitation, you will not post or transmit, or cause to
                  be posted or transmitted, any communication or solicitation or
                  other “phishing”, “pharming” or “whaling” message designed or
                  intended to obtain password, account, personal information,
                  confidential information or private information from any user
                  of the edu plus now platform or any other third party
                  whatsoever. However, if any such event does take place, edu
                  plus now shall not be liable for any loss in data or if the
                  user’s device, computer or any other property is compromised
                  in any manner.
                </li>

                <li>
                  You acknowledge and agree that edu plus now has the right to
                  report any and all suspicious or illegal activity to the
                  appropriate legal or police authorities without notice to you.
                </li>
                <br />
              </ol>

              <h5>
                During your use of the Platform and Programmes, you will not:
              </h5>

              <ol>
                <li>
                  harass other users, students, attendees, support agents or
                  visitors;
                </li>
                <li>
                  cheat on any homework assignment or exams for the programme;
                </li>
                <li> will not post online any secured testing materials;</li>
                <li>
                  {" "}
                  will not share solutions to homework assignments or exams; and
                </li>
                <li>
                  {" "}
                  will notify the instructors immediately if you become aware of
                  any other user cheating or breaching these Terms and will
                  comply with the requirements of the specific applicable code
                  of conduct, if any, relating directly to a programme in which
                  such user is enrolled.
                </li>
                <li>
                  Not to copy or distribute contents, videos, or documents
                  available on the edu plus now Platform
                </li>
              </ol>

              <br />

              <br />
              <h5>User Accounts, User Registration and Delivery of Services</h5>
              <ol>
                <li>
                  To enroll for a programme, you will need to register for a
                  personal account by providing a valid email address, a unique
                  password and such other additional details as may be requested
                  at the time of registration (‘Registered Account’). You
                  understand and agree that all information provided by you is
                  accurate, current and complete and that you will maintain and
                  update your information to keep it accurate, current and
                  complete. You acknowledge that if any information provided by
                  you is untrue, inaccurate, not current or incomplete, we
                  reserve the right to terminate your use of the platform and
                  your enrolment in a programme, to the extent applicable.
                </li>
                <li>
                  Upon payment of the programme fees, edu plus now shall deliver
                  the terms of use of the programme and will grant you access to
                  the course. The invoice may be provided to you along with the
                  email confirmation or within 7 (seven) days hereafter. This
                  shall be proof of receipt successful payment of fees.
                </li>
                <li>
                  {" "}
                  Owing to certain exceptional circumstances, if edu plus now
                  has granted you access to a programme pending payment, and edu
                  plus now does not receive payments within the stipulated time
                  periods, edu plus now may, at it owns discretion withdraw your
                  access to the programme, without giving any prior notice.
                </li>

                <li>
                  {" "}
                  You have complete responsibility for your Registered Account
                  and everything that happens on your Registered Account,
                  including for any harm or damage (to us or anyone else) caused
                  by someone using your account without your permission. You
                  agree that you will never divulge or share access to your
                  Registered Account, with any third party for any reason. You
                  also agree that you will create, use, and/or access only one
                  Registered Account, and that you will not use any Registered
                  Account other than your own.
                </li>
                <li>
                  In addition to the registration process, as part of your use
                  of the platform or participation in the programme, we may
                  obtain certain information about you and your performance in
                  the programmes. Some of this information may be personally
                  identifiable information. We may use, maintain, and store this
                  information to provide certain services to you now and in the
                  future and may share such information with our Educational
                  Partners or third parties in conjunction with such services or
                  for the purpose of marketing. For example, as further detailed
                  in our Privacy Policy, we may share certain materials or
                  information about you with third parties, including your
                  grades/scores in our classes.
                </li>

                <li>
                  Access to the Programmes is restricted to Students that have
                  specifically been granted access by edu plus now.
                </li>

                <br />
                <li>By registering your User Account, you agree that:</li>

                <ol>
                  <li>
                    you are registered for the programme only once and will not
                    set up multiple User Accounts; and
                  </li>
                  <li>
                    you will abide by these Terms and any terms specific to the
                    Programme.
                  </li>
                </ol>

                <br />
                <li>
                  As a student, in addition to the points above, you agree that
                  you are registering with the intent to complete the
                  assignments, if any, that are relevant and applicable to the
                  platform or programmes for which you have enrolled.
                </li>
              </ol>
              <h5>Payment Terms & Refund Policy</h5>

              <ol>
                <li>
                  Unless otherwise expressly agreed in writing by edu plus now,
                  full payment for participation in a programme is required at
                  the time of registration for Programme
                </li>

                <li>
                  Not with standing anything contained in this Terms of Use (i)
                  you are eligible to get refund of Programme Fees only and only
                  if we receive request for refund within in One days of payment
                  of such fees and in no other circumstances; (ii) The refund
                  request will be denied if in the opinion of edu plus now the
                  student has downloaded the course content before the request
                  for refund is sent.
                </li>

                <ol>
                  <br />
                  <h6>
                    If a student has purchased and then refunded multiple
                    courses, he/she may be subject to suspension for abuse of
                    the refund policy.
                  </h6>
                  <li>
                    {" "}
                    It is the sole responsibility of the User enrolling for a
                    programme to check the accuracy of, and evaluate the
                    suitability and relevance of, the programme elected.
                  </li>
                  <li>
                    The enrolment to a programme is non-transferable; in other
                    words Programme fees are not transferable.
                  </li>
                  <li>
                    Edu plus now reserves right to terminate your access to
                    Registered Account without any liability on edu plus now
                    including non-liability for refunding Programe fees if in
                    the opinion of edu plus now, you are in breach of these
                    Terms of Use.
                  </li>

                  <li>
                    You may cancel your enrolment at any time. No refund will be
                    made once payment (in part or whole) for a programme has
                    been made. We do not provide refunds for lack of usage or
                    dissatisfaction.
                  </li>

                  <li>
                    {" "}
                    To make payment for any programme offered by edu plus now
                    through the platform, you must have internet access and a
                    current valid accepted payment method as indicated during
                    sign-up (“Payment Method”). edu plus now does not store any
                    of your credit card information or such other information
                    restricted by RBI for processing payment and has partnered
                    with payment gateways for the payment towards the services.
                    By using a third-party payment provider, you agree to abide
                    by the terms of such payment provider. You agree that in
                    case edu plus now third-party payment provider stores any
                    such information, edu plus now will not be responsible for
                    such storage, and it will be solely at your discretion to
                    allow the third party to store such information. Any loss of
                    such information or any loss incurred by you due to usage of
                    such information will be solely a loss incurred by you, and
                    edu plus now is in no ways liable for any such losses and is
                    neither responsible to reimburse / make good such losses in
                    any manner whatsoever. You also agree to pay the applicable
                    fees for the payments made through the platform.
                  </li>
                  <li>
                    Failure to pay may result in withdrawal of your access to a
                    programme. Depending on where you transact with us, the type
                    of payment method used and where your payment method was
                    issued, your transaction with us may be subject to foreign
                    exchange fees or exchange rates. edu plus now does not
                    support all payment methods, currencies or locations for
                    payment. All applicable taxes are calculated based on the
                    billing information you provide us at the time of
                    enrollment/purchase.
                  </li>

                  <li>
                    {" "}
                    We have a right to reject application of a user seeking
                    admission.
                  </li>
                </ol>
                <br />
                <h5>Use of Programmes</h5>
                <ol>
                  <li>
                    {" "}
                    edu plus now reserves the right to cancel or reschedule any
                    programme or live lectures/webinars, or to alter, modify or
                    rearrange the schedule of topics, as well as the point value
                    or weight of assignments, tests, quizzes, exams, projects
                    and other such evaluations of progress. You also understand
                    that edu plus now, at its sole discretion, may limit,
                    suspend, or terminate your use of the platform or programmes
                    and/or all edu plus now-provided services related to the
                    programmes, such as access to professors or support
                    services, evaluation services, or certifications. You also
                    understand that edu plus now may modify or discontinue all
                    services related to its programmes at its sole discretion.
                    You agree that edu plus now shall not be liable to you or to
                    any third party for any such modification, suspension or
                    discontinuance. Nothing in these Terms shall be construed to
                    obligate edu plus now to maintain and support the platform
                    or programmes or any part or portion thereof or any
                    associated services. Nothing in these Terms shall be
                    construed to obligate edu plus now to maintain and support
                    the platforms, programmes or any part or portion thereof.
                    Students may be provided access to online lectures and
                    webinars via email. You agree not to share such access with
                    any third party.{" "}
                  </li>

                  <li>
                    You shall be exclusively responsible for obtaining and
                    maintaining any equipment or ancillary services needed to
                    connect to, access, receive or use the Platform, including,
                    without limitation, hardware devices, software, and other
                    internet, wireless, broadband, phone or other mobile
                    communication device connection services. You shall be
                    exclusively responsible for ensuring that such equipment or
                    ancillary services are compatible with the platform and
                    shall be responsible for all charges incurred in connection
                    with use of the platform and programme in connection with
                    all such equipment and ancillary services. The programme is
                    best viewed on the latest updated Browser.
                  </li>
                </ol>
                <br />
                <h5>Educational Partners & Accreditation</h5>
                <ol>
                  <li>
                    {" "}
                    EDU PLUS NOW IS NOT A UNIVERSITY, BUT AN EDUCATION SERVICE
                    PROVIDER, OFFERING PROGRAMMES IN CONSULTATION WITH INDIAN
                    AND INTERNATIONAL UNIVERSITIES, EDUCATIONAL INSTITUTIONS,
                    GOVERNMENTAL AUTHORITIES, NGO’S, CORPORATES ETC. (each an
                    “Educational Partner”).
                  </li>
                  <br />
                  <h6>
                    EDU PLUS NOW DOES NOT AWARD OR PROVIDE ANY DEGREE OR DIPLOMA
                    AS RECOGNIZED BY ANY UNIVERSITY.{" "}
                  </h6>

                  <li>
                    Admission to the degree/diploma programmes of an Educational
                    Partner is separate from being accepted into and/or taking
                    one or more Programmes. You agree and acknowledge that
                    nothing in these Terms or otherwise with respect to the use
                    of the Platform or any Programme (a) enrolls or registers
                    you in an Educational Partner, or any other school,
                    division, institute or programme of or associated with an
                    Educational Partner, (b) allows you to access or use the
                    resources or receive any benefits or privileges of any
                    Educational Partner, beyond the Programmes.
                  </li>

                  <li>
                    You acknowledge and agree that any programme affiliated with
                    an Educational Partner may be subject to terms, policies and
                    procedures of the applicable Educational Partner in addition
                    to edu plus now’s Terms. Without limiting the foregoing, if
                    you are a student registered or enrolled at, or are
                    otherwise attending, an Educational Partner and are taking a
                    programme for credit or certification through that
                    Educational Partner, you acknowledge and agree that (a) the
                    Educational Partner may have its own terms, policies or
                    procedures regarding your eligibility to participate in the
                    programme, your participation in the programme, the
                    requirements or prerequisites for receiving credit or
                    certification for the programme, and/or your educational or
                    student records as they may relate to your participation and
                    performance in the programme, and (b) your educational or
                    student records are maintained by the Educational Partner,
                    including for purposes of assigning credit or certification,
                    and not edu plus now.
                  </li>

                  <li>
                    {" "}
                    edu plus now may offer a credential or other acknowledgment
                    for participants who have satisfactorily demonstrated
                    mastery of the Programme material. The decision to award any
                    such credential acknowledgment to a given participant will
                    be solely within the discretion of edu plus now. edu plus
                    now may choose not to offer any credential or other
                    acknowledgment for some Programmes. It may decide at its
                    sole discretion whether to provide a record concerning a
                    participant’s performance in a Programme. The format of any
                    credential or other acknowledgement, and of any performance,
                    provided by edu plus now relating to Programmes will be
                    determined by edu plus now in its sole discretion and may
                    vary from Programme to Programme.
                  </li>

                  <li>
                    {" "}
                    Enrollment for Programme or complete of programme does not
                    guarantee any specific enhancement in your skill.
                  </li>
                  <li>
                    edu plus now programmes are self-paced courses that contain
                    videos, assignments and quizzes. You may be awarded a
                    certificate of accomplishment upon successful completion of
                    a Programme (“Programme Certificate”), solely at the
                    discretion of edu plus now.
                  </li>

                  <li>
                    You will not receive academic credit from edu plus now for
                    taking a programme.
                  </li>
                </ol>
                <br />
                <h5>edu plus now’s Intellectual Property Rights</h5>

                <ol>
                  <li>
                    The platform, programmes and related services are owned and
                    operated by edu plus now and its licensors. All Content or
                    other material available on the Platform or through the
                    programmes, including but not limited to on-line/live
                    lectures, speeches, video lessons, quizzes, presentation
                    materials, homework assignments, programming assignments,
                    programmes, code, and other images, text, layouts,
                    arrangements, displays, illustrations, documents, materials,
                    audio and video clips, HTML and files (collectively “edu
                    plus now Content”), are the property of edu plus now and/or
                    its affiliates or licensors and are protected by copyright,
                    patent and/or other proprietary intellectual property rights
                    under India and foreign law. All software used on the
                    Platform is the property of edu plus now and is protected by
                    Indian and international copyright laws.
                  </li>

                  <li>
                    edu plus now logos, trademarks and service marks which may
                    appear on the platform and in the programme, are the
                    property of edu plus now and are protected under Indian and
                    foreign laws. All other trademarks, service marks and logos
                    used on the platforms, online courses or programmes, with or
                    without attribution, are the trademarks, service marks or
                    logos of their respective owners. In addition, elements of
                    the platforms are protected by trade dress and other Indian
                    and international intellectual property laws and shall not
                    be copied, reproduced, downloaded or distributed in any way
                    in whole or in part without the express written consent of
                    edu plus now.
                  </li>

                  <li>
                    {" "}
                    As a condition of accessing the platforms and/or using the
                    programmes, you agree not to (a) reproduce, duplicate, copy,
                    sell, resell or exploit for any commercial purpose any edu
                    plus now Content or any portion thereof, other than as
                    expressly allowed under these Term of Uses; (b) use the edu
                    plus now Marks or the name, trademarks, service marks, or
                    other materials of any Educational Partner in connection
                    with, or to transmit, any unsolicited communications or
                    emails or for any other unauthorized purpose.
                  </li>

                  <li>
                    Please verify all Content prior to use. In the event you
                    come across any Content which is incorrect, infringing,
                    offensive, indecent or objectionable, please notify us
                    immediately at address mentioned at the bottom of this page.
                  </li>

                  <li>
                    Additionally, from time to time, edu plus now (or its
                    third-party service providers on behalf of edu plus now) may
                    request users to review edu plus now Content or beta test
                    the Platform. The works derived from such activity shall
                    remain the sole and exclusive property of edu plus now or
                    its third-party service providers, as applicable.
                  </li>
                </ol>

                <h5> Third Party Intellectual Property</h5>
                <ol>
                  <li>
                    edu plus now respects third party intellectual property
                    rights and actively supports protection of all third-party
                    intellectual property including copyrights and trademarks
                    (“IP”). It is our policy to expeditiously respond to clear
                    notices of alleged IP infringement. If we receive proper
                    notification of IP infringement, our response to such
                    notices will include removing or disabling access to
                    material claimed to be the subject of infringing activity.
                  </li>

                  <li>
                    edu plus now shall not be held liable for the unauthorized
                    use of any third-party IP, and the User/Student that carries
                    out such unauthorized use, or infringes any IP available on
                    the Platform shall fully indemnify and hold edu plus now
                    harmless against any and all claims that may arise as a
                    result of such use.
                  </li>
                </ol>
                <br />
                <h5>Limited License</h5>
                <br />

                <ol>
                  <li>
                    The services on the Platform are licensed in limited manner,
                    and not sold. In consideration for your agreement to these
                    Terms of Use, edu plus now grants you a personal,
                    non-exclusive, non-transferable, revocable license to access
                    and use the Platform and Programmes, solely in accordance
                    with the Terms. You may not copy, sell, re-sell, reproduce,
                    publish, modify, transfer, retransmit, distribute,
                    commercially exploit or create derivative works of
                    Platforms, Programmes or any edu plus now Content. You may
                    not reverse-engineer, decompile, disassemble or otherwise
                    code for any software that may be used to operate the
                    Platform or the Programmes. Notwithstanding the foregoing,
                    certain reference documents, digital textbooks and articles
                    may be made available to you with the permission of third
                    parties and use of that information is subject to certain
                    rules and conditions, and you agree to abide by all such
                    rules and conditions.
                  </li>

                  <li>
                    You may not reverse-engineer, decompile, disassemble or
                    otherwise access the source code for any software that may
                    be used to operate the Platform or the Programmes. From time
                    to time, edu plus now may include software, code,
                    instructions, or other such information in the edu plus now
                    Content for the Programmes; any such information is provided
                    on an “as-is” basis for instructional purposes only and is
                    subject to the ‘Disclaimer’ and ‘Limitation of Liability’
                    sections below and other terms herein. Any use of Content
                    for commercial purposes is strictly prohibited. edu plus now
                    and/or its affiliates and licensors reserve all rights not
                    expressly granted herein to the Platforms, edu plus now
                    Content, and edu plus now Marks.
                  </li>

                  <li>
                    Without limiting the generality of the terms above, the
                    following are types of uses that edu plus now expressly
                    defines as falling outside of the definition of
                    "non-commercial and personal use":
                  </li>

                  <li>
                    the sale or rental of (i) any part of the edu plus now
                    Content, (ii) any derivative works based at least in part on
                    the edu plus now Content, or (iii) any collective work that
                    includes any part of the edu plus now Content;
                  </li>

                  <li>
                    the sale of access or a link to any part of the edu plus now
                    Content;
                  </li>

                  <li>
                    providing training, support, or editorial services that use
                    or reference the edu plus now Content in exchange for a fee;
                  </li>

                  <li>
                    the use of edu plus now Content by a college, university,
                    school, or other educational institution for instruction
                    where tuition is charged;
                  </li>

                  <li>
                    the use of edu plus now Content by a for-profit corporation
                    or non-profit entity for internal professional development
                    or training; and
                  </li>
                  <li>
                    the use of edu plus now Content for display/ upload/ making
                    available at a place that is accessible to general public in
                    any manner, including but not limited to any social media
                    sites, video download sites, torrents.
                  </li>
                </ol>
                <br />
                <h5>User Content</h5>
                <ol>
                  <li>
                    The Platform may provide you with the ability to upload
                    forum posts, chat with other users and edu plus now’s
                    counsellors, user discussions, profile pages, and other
                    content and media for social interaction, or certain
                    information and materials for use with the programmes, e.g.,
                    questions, hypotheticals, examples, assignments, industry
                    projects etc. (collectively, “User Content”). edu plus now
                    does not claim ownership of any User Content you may submit
                    or make available for inclusion on the platform or
                    programmes. Accordingly, subject to the license granted to
                    edu plus now above, the user will be the sole and exclusive
                    owner of any and all rights, title and interest in and to
                    the User Content.
                  </li>

                  <li>
                    With respect to any User Content you submit via the platform
                    or programmes or that is otherwise made available to edu
                    plus now, you hereby grant edu plus now an irrevocable,
                    worldwide, perpetual, royalty-free and non-exclusive license
                    to use, distribute, reproduce, modify, adapt, publicly
                    perform and publicly display such User Content on the
                    platforms or in the programmes or otherwise exploit the User
                    Content, with the right to sublicense such rights (to
                    multiple tiers), for any purpose (including for any
                    commercial purpose). edu plus now reserves the right to
                    remove any User Content at any time and for any reason.
                  </li>

                  <li>
                    To the extent that you provide any User Content, you
                    represent and warrant that (a) you have all necessary
                    rights, licenses and/or clearances to provide such User
                    Content and permit edu plus now to use such User Content as
                    provided above, (b) such User Content is accurate and
                    reasonably complete, (c) as between you and edu plus now,
                    you shall be responsible for the payment of any third party
                    fees related to the provision and use of such User Content,
                    and (d) such User Content does not and will not infringe or
                    misappropriate any third party rights or constitute a
                    fraudulent statement or misrepresentation or unfair business
                    practices.
                  </li>

                  <li>
                    edu plus now does not control the User Content posted
                    through the Platform, including any messages, reviews or
                    comments, and does not guarantee the accuracy, integrity or
                    quality of such User Content. Under no circumstances edu
                    plus now be liable in any way for any User Content,
                    including any errors or omissions, or any loss or damage or
                    defamation of any kind incurred as a result of your posting
                    or use of any User Content. You are responsible for
                    complying with all laws applicable to the User Content.
                  </li>

                  <li>
                    You are prohibited from posting the following Content on the
                    platform:
                  </li>

                  <li>
                    Content that is fraudulent, indecent, or libelous or
                    defames, harasses, discriminates against, harms or threatens
                    others;
                  </li>

                  <li>
                    Content that discusses illegal activities, with the intent
                    to commit them;
                  </li>

                  <li>
                    Content that infringes or misappropriates patent, trademark,
                    trade secret, right of publicity, or other intellectual
                    property rights of third parties;
                  </li>

                  <li>Content that you do not have the right to disclose;</li>

                  <li>
                    Profane, pornographic, obscene, indecent or unlawful
                    Content;
                  </li>

                  <li>Advertising or any form of commercial solicitation;</li>

                  <li>Content related to partisan political activities;</li>

                  <li>
                    Content that contains intentionally inaccurate information
                    or that is posted with the intent of misleading others;
                  </li>

                  <li>
                    Viruses, Trojan horses, worms, time bombs, cancelbots, or
                    other disabling devices or other harmful components intended
                    to or that may damage, detrimentally interfere with,
                    surreptitiously intercept, or expropriate any system, data,
                    or personal information;
                  </li>

                  <li>
                    That consists of any high volume, automated, or electronic
                    means to access the platform (including without limitation
                    robots, spiders or scripts);
                  </li>

                  <li>
                    That violates the rights of other users of the platform; or
                  </li>

                  <li>
                    That violates any applicable local, state, national or
                    international law or otherwise advocates or encourages any
                    illegal activity.
                  </li>
                </ol>
                <br />
                <h5>Platform Security</h5>
                <ol>
                  <li>
                    You are prohibited from violating or attempting to violate
                    the security of the Platform or any other associate platform
                    of edu plus now, including, without limitation, (a)
                    accessing data not intended for such user or logging onto a
                    server or an account which the user is not authorized to
                    access; (b) attempting to probe, scan or test the
                    vulnerability of a system or network or to breach security
                    or authentication measures without proper authorization; (c)
                    attempting to interfere with service to any user, host or
                    network, including, without limitation, via means of
                    submitting a virus to the Platform, overloading, “flooding,”
                    “spamming,” “mailbombing” or “crashing;” (d) sending
                    unsolicited email, including promotions and/or advertising
                    of products or services; or (e) forging any TCP/IP packet
                    header or any part of the header information in any email or
                    newsgroup posting. Violations of system or network security
                    may result in civil or criminal liability. edu plus now will
                    investigate occurrences that may involve such violations and
                    may involve, and cooperate with, law enforcement authorities
                    in prosecuting users who are involved in such violations.
                    You agree not to use any device, software or routine to
                    interfere or attempt to interfere with the proper working of
                    this platform or any activity being conducted on the
                    platform. You agree, further, not to use or attempt to use
                    any engine, software, tool, agent or other device or
                    mechanism (including without limitation browsers, spiders,
                    robots, avatars or intelligent agents) to navigate or search
                    the platform other than the search engine and search agents
                    available from edu plus now on the platform and other than
                    generally available third-party web browsers (e.g., Google
                    Chrome or Microsoft Explorer).
                  </li>
                </ol>
                <br />
                <h5>Disclaimer</h5>
                <ol>
                  <li>
                    The platform and/or programmes may contain typographical
                    errors or inaccuracies and may not be complete or current.
                    edu plus now therefore reserves the right to correct any
                    errors, inaccuracies or omissions (including after an order
                    has been submitted) and to change or update information at
                    any time without prior notice.
                  </li>

                  <li>
                    The platform, programmes, and any information or edu plus
                    now Content are provided “as is” and “as available” basis
                    with all faults.
                  </li>

                  <li>
                    edu plus now makes no representations or warranties of any
                    kind, whether express or implied, with respect to edu plus
                    now Content or services available on or through this
                    platform and programmes, including, but not limited to, the
                    implied warranties of merchantability, fitness for a
                    particular purpose, and non-infringement. edu plus now makes
                    no warranty that the services will meet the User’s/Students
                    requirements or that the services will be uninterrupted,
                    timely, secure, or error free; nor does edu plus now make
                    any warranty as to the results that may be obtained from the
                    use of the services, or as to the accuracy or reliability of
                    any information obtained through the services, or that any
                    defects in the software will be corrected.
                  </li>

                  <li>
                    The user understands and agrees that edu plus now Content
                    and all other information, data, or other material
                    downloaded or otherwise obtained through or from the
                    Platform or Programmes is obtained at the user’s own
                    discretion and risk, and that the user will be solely
                    responsible for any damage to the user, the user’s computer
                    system, electronic device or any loss of data that results
                    from the download of such material or data.
                  </li>

                  <li>
                    No advice or information, whether oral or written, obtained
                    by the user from edu plus now or through or from the
                    services, shall create any warranty by edu plus now.
                  </li>

                  <li>
                    In the event you find that the information provided on the
                    Platform or Programmes is incorrect, or if you are the owner
                    of any information or content and wish that such information
                    or content is not displayed on the platform or programmes,
                    kindly notify us at the address provided at the bottom of
                    the page.
                  </li>
                </ol>
                <br />
                <h5>Limitation of Liability</h5>
                <ol>
                  <li>
                    Neither edu plus now nor any of its Educational Partners,
                    affiliates, employees, directors, officers, agents, vendors
                    or supplier shall be liable to you or any other person,
                    whether in Tort, Contract, Strict Liability or otherwise,
                    for any direct, indirect, special, incidental or
                    consequential losses or damages or costs of any nature
                    arising out of or in connection with the use or inability to
                    use this platform or programmes, including, without
                    limitation, damages for lost profits, loss of goodwill, loss
                    of data, work stoppage, accuracy of search results, or
                    computer / electronic device failure, virus or malfunction.
                    In no event will edu plus now be liable for any damages in
                    excess of Rupees 100 or, in the case of enrolled students,
                    the 10% of fees paid by you in connection with your
                    enrollment to a Programme.
                  </li>
                </ol>

                <h5>Site Linking</h5>
                <ol>
                  <li>
                    The platform may contain links to pages on other websites
                    (“Linked Sites”), and those Linked Sites may contain Content
                    or offer products and/or services for sale. edu plus now
                    does not author, edit, control, or monitor these Linked
                    Sites. You acknowledge and agree that (a) we have no
                    responsibility for the accuracy or availability of
                    information provided by Linked Sites, (b) we do not control
                    or endorse the sponsors of such Linked Sites or the content,
                    products, advertising, or other materials presented on such
                    Linked Sites. and © you agree to the terms and conditions of
                    the Linked Sites We may remove any Linked Sites from the
                    Platform at any time with or without reason.
                  </li>

                  <li>
                    EDU PLUS NOW WILL NOT BE LIABLE FOR ANY TRANSACTIONS
                    CONDUCTED BY YOU WITH THIRD PARTIES THROUGH THE LINKED SITES
                    OR FOR ANY LIABILITY ARISING FROM THE REPRESENTATIONS OR
                    INFORMATION PROVIDED ON SUCH LINKED SITES.
                  </li>
                  <br />
                  <b>
                    We appreciate that Linked Sites may contain material in
                    which the operator of the Linked Sites has intellectual
                    property rights. We respect those rights and provide the
                    links for information purposes only. The fact that we have
                    linked to any Linked Site does not create or imply any
                    relationship or partnership with the operator of such Linked
                    Site.
                    <br /> You may not establish a link to this platform from
                    any other website, application, intranet or extranet site
                    without our prior written consent. If you wish to create
                    links, you may contact us before doing so. In establishing
                    links, you must not represent in any way, expressly or by
                    implication, that you have received the endorsement,
                    sponsorship or support of edu plus now, including its
                    Educational Partners, respective employees, agents,
                    directors, officers or shareholders.
                  </b>
                </ol>
                <br />
                <h5>Indemnity</h5>
                <ol>
                  <li>
                    You agree to indemnify and hold edu plus now (including its
                    directors, employees, representatives, consultants etc.) and
                    its Educational Partners including its directors, employees,
                    representatives, consultants etc.) harmless from any and all
                    claims, liabilities, damages, losses and expenses, including
                    reasonable attorneys’ fees and costs, relating to or arising
                    out of (a) your use or attempted use of the Platforms or
                    Programmes in violation of the Terms of Use; (b) your
                    violation of any law or rights of any third party; or (c)
                    information or Content that you or others post or otherwise
                    make available on the platform or through any programme,
                    including without limitation any claim of infringement or
                    misappropriation of intellectual property or other
                    proprietary rights.
                  </li>
                </ol>
                <br />
                <h5>Termination of Rights</h5>
                <ol>
                  <li>
                    You agree that edu plus now, in its sole discretion, may
                    deactivate your account or otherwise terminate your use of
                    the platform or enrollment to a programme with or without
                    reason, including, without limitation, if edu plus now
                    believes that you have (a) breached the Terms of Use; (b)
                    infringed the intellectual property rights of a third party;
                    (c) posted, uploaded or transmitted unauthorized Content on
                    the platform; or (d) violated or acted inconsistently with
                    the letter or spirit of these Terms or any other applicable
                    code of conduct or indulged in unauthorized distribution or
                    piracy of confidential information of edu plus now. You
                    agree that any deactivation or termination of your access to
                    the platforms or programmes may be affected without prior
                    notice to you and that edu plus now shall not be liable to
                    you nor any third party for any termination of your account
                    or enrollment to a programme. You also acknowledge that edu
                    plus now may retain and store your information on edu plus
                    now’s systems notwithstanding any termination of your
                    account or enrollment to the programmes.
                  </li>
                </ol>
                <br />
                <h5>Miscellaneous Provisions</h5>
                <ol>
                  <li>
                    By accepting the Terms through your use of the platform, you
                    certify that you are 18 years of age or older. If you are
                    under the age of 18 or under the legal age in your
                    jurisdiction to enter into a binding contract you may use
                    the platform only under the supervision of a parent or legal
                    guardian who agrees to be bound by the Terms. If you are a
                    parent or legal guardian agreeing to the Terms for the
                    benefit of a child below 18, be advised that you are fully
                    responsible for his or her use of the platform, including
                    all financial charges and legal liability that he or she may
                    incur. By using the platform, you represent and warrant that
                    you have the right, authority, and capacity to enter into
                    the Terms and to abide by all of the terms and conditions
                    set forth herein. The programmes are not for the use of
                    individuals under the age of 18 years.
                  </li>
                  <li>
                    edu plus now may freely transfer or assign any portion of
                    its rights or delegate its obligations under these Terms or
                    any programme specific terms. You shall not transfer or
                    assign, by operation of law or otherwise, any portion of
                    your rights or delegate your obligations under these Terms
                    or any programme specific terms without the prior written
                    consent of edu plus now.
                  </li>
                  <li>
                    These Terms or any programme specific terms shared with you,
                    shall be governed by, construed and enforced in accordance
                    with the laws of India, as it is applied to agreements
                    entered into and to be performed entirely within India and
                    without giving effect to any principles of conflict of laws.{" "}
                  </li>
                  <li>
                    Where a dispute arises in connection with, related to or
                    arising out of these Term of use, the parties to the dispute
                    or involved shall make all reasonable efforts to resolve the
                    dispute through good faith negotiations. If efforts to
                    amicably resolve any dispute or claim between the parties
                    are unsuccessful within 30 days from the first day of
                    referral for such good faith negotiation, then such dispute
                    or claim arising out of or in connection with the Terms or
                    any programme specific terms shared with you, including any
                    question regarding its existence, validity or termination,
                    shall be referred to arbitration under the Arbitration &
                    Conciliation Act, 1956, as amended (“Act”) before a sole
                    arbitrator to be mutually appointed by the disputing
                    parties, failing which, the sole arbitrator shall be
                    appointed in the manner provided in the Act. The proceedings
                    shall be conducted in English and the seat for arbitration
                    shall be Pune. Fees of Arbitrator shall be paid in equal
                    proportion by parties to the dispute.
                  </li>
                  <li>
                    Subject to provisions of the arbitration, courts at Pune
                    shall have exclusive jurisdiction.
                  </li>
                  <li>
                    If any provision of the Terms of Use or any programme
                    specific terms shared with you is found to be unlawful,
                    void, or for any reason unenforceable, then that provision
                    shall be deemed severable from the other provisions herein
                    and shall not affect the validity and enforceability of any
                    remaining provisions. edu plus now shall have no liability
                    under these Terms or any programme specific terms shared
                    with you, to the extent arising from any failure of edu plus
                    now to perform any of its obligations under these Terms or
                    any programme specific terms shared with you, due to any
                    fire, flood, earthquakes, other acts of God, war, civil
                    unrest, terrorism, Internet failures, governmental act or
                    court order, national emergency, strikes or labor disputes
                    or any other event not within edu plus now’s reasonable
                    control. edu plus now shall not be responsible for damage or
                    other problems caused by any unauthorized change to these
                    Terms made by way of hacking or cracking this page.
                  </li>
                  <li>
                    The failure of edu plus now to exercise or enforce any right
                    or provision of the Terms or any programme specific terms
                    shared with you, shall not constitute a waiver of such right
                    or provision. If any provision of the Terms or any programme
                    specific terms shared with you, is found by a court of
                    competent jurisdiction to be invalid, the parties
                    nevertheless agree that the court should endeavor to give
                    effect to the parties’ intentions as reflected in the
                    provision, to the extent that may lawfully be done, and the
                    other provisions of these Terms or any programme specific
                    terms shared with you, shall remain in full force and
                    effect.
                  </li>
                  <li>
                    These Terms or any programme specific terms shared with you,
                    constitute the entire agreement between you and edu plus now
                    relating to the matters set forth herein, and shall not be
                    modified except in writing, as posted on the platforms by
                    edu plus now or through a specific writing between you and
                    edu plus now.
                  </li>
                  <li>
                    edu plus now may freely transfer or assign any portion of
                    its rights or delegate its obligations under the Terms or
                    any programme specific terms shared with you. You may not
                    transfer or assign, by operation of law or otherwise, any
                    portion of your rights or delegate your obligations under
                    the Terms or any programme specific terms shared with you,
                    without the prior written consent of edu plus now, and any
                    attempted such transfer or assignment shall be void and of
                    no effect.
                  </li>
                  <li>
                    All rights and remedies mentioned in these Terms of Use or
                    in law or equity are cumulative and can be pursued
                    simultaneously.
                  </li>
                  <li>
                    Any notice or communication which may be required to be
                    given to edu plus now under these Terms or any programme
                    specific terms shared with you, may be sent by writing or
                    emailing to the following address:
                  </li>
                  <br />
                  CONTACT
                  <br />
                   Udnav Erp Software Technologies Llp
                  <br />
                  <br />
                  Suyog Center, 7th Floor, <br />
                  Gultekadi Marketyard Road, <br />
                  Giridhar Bhavan Chowk
                  <br />
                  Pune-411037
                  <br />
                  Maharashtra
                  <br />
                  Phone: 020 245 25550
                  <br />
                </ol>
              </ol>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Termsandconditionspage;
